import React, {FunctionComponent} from 'react'
import {Navbar} from "@App/Components/Navbar";
import {Footer} from "@App/Layouts/Footer";
import {Outlet} from "react-router-dom";

export const Layout: FunctionComponent = () => {
    return (
        <div className="text-neutral-400">
            <Navbar>
                <a href={'https://www.repareo.de'} className={'flex'} title={"repareo Werkstattvergleich"}>
                    <img
                        src="/images/brand/logo-light.svg"
                        className="w-24 h-auto"
                        alt=""
                    />
                </a>
            </Navbar>
            <Outlet/>
            <Footer/>
        </div>
    )
}
